export default __webpack_public_path__ + "static/media/brick.f83bae02.svg";